<!-- 合规-信息收集包装-->
<template>
  <div class="collection-layout" v-loading="loading">
    <template v-if="!loading">
      <template v-if="visible">
        <el-result
          icon="warning"
          title="保护用户隐私是我们的责任。若您需要查看用户敏感个人信息，必须提交专门的权限申请。请注意，您将只能访问与当前订单相关联的用户信息。"
          style="width: 70%; margin: 0 auto"
        >
          <template slot="extra">
            <el-alert
              class="collection-content"
              title=""
              type="error"
              center
              :closable="false"
            >
              <template #title>
                <span>
                  请严格遵循隐私保护原则：绝不可向外透露任何用户的个人隐私信息。这包括但不限于用户的录音、行程轨迹、身份信息等敏感数据。我们将对任何违反这些规定的行为进行调查，并将根据
                  <el-link type="primary" :underline="false" href="https://www.gov.cn/xinwen/2016-11/07/content_5129723.htm"  target="_blank">《网络安全法》</el-link>、 <el-link type="primary" :underline="false" href="https://www.gov.cn/xinwen/2021-08/20/content_5632486.htm"  target="_blank">《个人信息保护法》</el-link>、以及 <el-link type="primary" :underline="false" href="https://www.spp.gov.cn/spp/fl/201802/t20180206_364975.shtml"  target="_blank">《中华人民共和国刑法》</el-link>的相关规定，追究相应的民事和刑事责任。请您重视这一通知，并在使用过程中确保遵守所有相关法律法规。
                </span>
              </template>
            </el-alert>
            <div>
              <el-button
                type="primary"
                size="medium"
                @click="showDialog"
                style="margin-top: 35px"
                >申请查看本次权限</el-button
              >
            </div>
            <div>
              <el-checkbox v-model="checked" style="margin-top: 15px"
                >我已同意并阅读</el-checkbox
              >
            </div>
          </template>
        </el-result>
      </template>
      <slot v-else></slot>
    </template>
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";
import { Message } from "element-ui";

import useFetch from "@/hooks/useFetch";

import { queryRecordingUseReasonDialogIsDisplayed } from "@/api/components/collectInForDialog";

import { showCollectInForDialog } from "@/components/CollectInForDialog/index.js";

const props = defineProps(["params"]);

let visible = ref(true);
let loading = ref(true);
let checked = ref(true); // 是否同意
const emit = defineEmits(["submit"]);

const showDialog = () => {
  if (!checked.value) {
    return Message.warning("请勾选我已同意并阅读");
  }
  const { object_type, audio_type, button_type, object_id } = props.params;
  showCollectInForDialog(
    {
      object_type,
      audio_type,
      button_type,
      object_id,
    },
    {
      onSubmit: () => {
        visible.value = false;
        nextTick(() => {
          emit("submit");
        });
      },
      onCancel: () => {
        // visible.value = false;
        emit("cancel");
      },
    }
  );
};
const init = (params) => {
  loading.value = true;
  if (!params?.object_id) {
    loading.value = false;
    return;
  }
  useFetch(queryRecordingUseReasonDialogIsDisplayed, {
    params,
    onFinish: (res) => {
      const { confirm_pop = false } = res;
      // true-展示理由弹窗，false-不展示，告知外层走正常逻辑
      visible.value = confirm_pop;
      emit("submit");
      loading.value = false;
    },
    onError: (err) => {
      loading.value = false;
    },
  });
};

init(props.params);
</script>
<style lang="scss" scoped>
.collection-layout {
  /* border: 1px solid #ebebeb; */
  background: #fff;
  ::v-deep {
    .el-result__title {
      font-size: 16px;
    }
  }
}
</style>
